import { useNavigate } from 'react-router-dom';
import forbidPage from '../../assets/svg/unauthorised.svg';
import Button from '../../components/atoms/Button/Button';
import styles from './Forbidden.module.scss';
const Forbidden = () => {
    let navigate = useNavigate();
    return (
        <div className={styles.wrapperForbid}>
            <img src={forbidPage} alt="forbid" className={styles.forbid} />
            <div className={styles.info}>Access Forbidden</div>
            <div className={styles.description}>You do not have permission to access on this page</div>
            <div className={styles.center}> <Button variant="primary-partner" btnText="Go Back" onClick={() => {
                navigate(-1);
                setTimeout(
                    () => { window.location.reload(); }
                    , 1000) //Use Settimeout since navigate is async
            }} /></div>
        </div>
    )
}

export default Forbidden;